import { useNavigate } from 'react-router-dom';
import { Button, Typography } from '@equinor/eds-core-react';
import * as Styled from './ConvertToModel.styled';

type ConvertToModelProps =
  | { onConvert?: () => void; isConverting: boolean; analogueModelId?: never }
  | { analogueModelId: string; onConvert?: never; isConverting?: never };

export const ConvertToModel = ({
  onConvert,
  isConverting,
  analogueModelId,
}: ConvertToModelProps) => {
  const navigate = useNavigate();

  return (
    <Styled.Container>
      <Typography variant="h5">Analogue Model</Typography>
      {analogueModelId ? (
        <Button onClick={() => navigate(`/models/${analogueModelId}`)}>
          Go to Analogue Model
        </Button>
      ) : onConvert ? (
        <Button onClick={onConvert} disabled={isConverting}>
          {isConverting ? 'Moving...' : 'Move to Model Library'}
        </Button>
      ) : (
        <Typography variant="body_short">
          You must be the scenario owner to move model to analogue model
          library.
        </Typography>
      )}
    </Styled.Container>
  );
};
